<template>
    <administrative>

        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table
                :searchlink="route('administrative.staff.search')"
                :fields="fields"
                :items="staffs"
                :canCreate="hasRole('View Staff')"
                :canView="$page.props.auth.user.role.permissions.find(permission => permission.name === 'View User')"
            >
                <template #role="data">{{ data.item.role ? data.item.role.name : '' }}</template>
                <template #action="data">
                    <button-link v-if="hasRole('Edit Staff')" :href="route('administrative.staff.edit',data.item.id)">
                        Edit
                    </button-link>
                </template>
            </breeze-table>
        </div>
    </administrative>
</template>

<script setup>
import Administrative from "@/Pages/Administrative/Administrative";
import BreezeTable from "@/Components/Table";
import ButtonLink from "@/Components/ButtonLink";
import {ref} from "vue";

import * as htmlToImage from "html-to-image";
import {hasRole} from "../../../../Utils/checkPermission";

function getImage() {
    htmlToImage.toBlob(document.getElementById('my-node'))
        .then(function (blob) {
            if (window.saveAs) {
                window.saveAs(blob, 'my-node.png');
            } else {
                FileSaver.saveAs(blob, 'my-node.png');
            }
        });
}

defineProps({
    staffs: Object
});
const fields = ref([
    {key: "name", label: "Name"},
    {key: "mobile", label: "Mobile"},
    {key: "email", label: "Email"},
    {key: "action", label: "Action"}
]);
</script>
